import * as React from 'react';
import './mud.css';

const Home = ({ who }) => (
  <div className="lots-shell">
    <div className="lots-container">
      <div className="lots-hero">
        <div className="portal-kicker">Legacy of the Sith</div>
        <h1 className="lots-hero__title">A living Star Wars MUD</h1>
        <p className="lots-hero__subtitle">
          Step into a shared galaxy of roleplay, war, and diplomacy. We are the 9th longest running online game, with a
          continuous story unfolding since 2000. Play from the web, or connect using your favorite MUD client for the
          deepest experience.
        </p>
        <div className="portal-cta-row">
          <a className="lots-btn" href="/mud">Play Online (alpha)</a>
          <a className="lots-btn lots-btn--ghost" href="/character/new">Create Character</a>
          <a className="lots-btn lots-btn--ghost" href="/how-to-play">How to Play</a>
        </div>
      </div>

      <div className="lots-grid lots-grid--three">
        <div className="lots-card lots-card--accent">
          <div className="portal-kicker">New to MUDs</div>
          <h3>Learn fast</h3>
          <p>Get a guided primer, essential commands, and your first objectives.</p>
          <a className="lots-btn lots-btn--ghost" href="/how-to-play">Start here</a>
        </div>
        <div className="lots-card">
          <div className="portal-kicker">New to LotS</div>
          <h3>Pick your path</h3>
          <p>Choose a faction, find a mentor, and make your first impact within minutes.</p>
          <div className="portal-note">Check the Player Portal for faction guides once you log in.</div>
        </div>
        <div className="lots-card">
          <div className="portal-kicker">Returning Players</div>
          <h3>Jump back in</h3>
          <p>Use OTP login to connect in seconds and rejoin your last story arc.</p>
          <a className="lots-btn lots-btn--ghost" href="/mud">Launch the cockpit</a>
        </div>
      </div>

      <div className="portal-layout" style={{ marginTop: '2rem' }}>
        <div className="portal-main">
          <div className="portal-section">
            <div className="portal-kicker">Live</div>
            <h3>Who's Online</h3>
            <pre className="mud" dangerouslySetInnerHTML={{ __html: who || '' }} />
          </div>
        </div>
        <aside className="portal-rail">
          <div className="lots-card">
            <div className="portal-kicker">Preferred clients</div>
            <h4>Mudlet + MUSHclient</h4>
            <p>
              For scripting, triggers, and full ANSI support, use a dedicated client with
              <strong> legacyofthesith.com</strong> on port <strong>3000</strong>.
            </p>
          </div>
          <div className="lots-card">
            <div className="portal-kicker">Need help?</div>
            <h4>Join OOC chat</h4>
            <p>Ask for help, mentors, and live event updates inside the Player Portal.</p>
          </div>
        </aside>
      </div>
    </div>
  </div>
);

export default Home;
